import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Formula', value: data.formulaName, fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
        { label: 'Available Storage', value: data.availableStorage },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title="Formula"
            id={data.id}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
